import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography, Space, Row, Col } from 'antd';

import { CommonFormProps, OnboardingLayout } from '.';
import { BackButton, Form } from '~/components';
import { useResetOnboardingState } from '~/hooks/onboarding';
import { createPath } from '../Sider';
import onError from '~/errorsHandler';

const { Title, Text } = Typography;

const AccountExist: FC<CommonFormProps> = (props) => {
  const { history } = props;
  const { t } = useTranslation('onboarding');
  const dt = (key: string): string => t(`translation:${key}`);

  const handleClick = () => {
    try {
      history.push('/login');
    } catch (error: any) {
      onError(error);
    }
  };

  const resetOnboarding = useResetOnboardingState();
  const goBack = () => {
    resetOnboarding();
    history.push(createPath('personalInfo'));
  };

  return (
    <OnboardingLayout>
      <Title level={2}>{t('accountExistHeader')}</Title>
      <Space size="middle" direction="vertical">
        <Text>{t('accountExistSubtitle')}</Text>
        <Row gutter={16}>
          <Col>
            <BackButton onClick={goBack} size="large" />
          </Col>
          <Col>
            <Form.Item noStyle>
              <Button type="primary" size="large" onClick={handleClick}>
                {dt('login')}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Space>
    </OnboardingLayout>
  );
};

export default AccountExist;
